import { Typography } from '@mui/material';
import React from 'react';
import { Modal } from 'ui/components/Modal/Modal';
import { CreateAccountModalProps } from './types';
import { FishbowlSpinner } from 'ui/theme';
import { useCreateAccountModalStyle } from './styled';

const titleBar = () => <></>;

const CreateAccountModal = (props: CreateAccountModalProps) => {
  const { open } = props;
  const classes = useCreateAccountModalStyle();

  const handleClose = (
    event: React.ChangeEvent<HTMLInputElement>,
    reason: string
  ) => {
    if (reason && reason === 'backdropClick') return;
  };
  return (
    <Modal
      className={classes.modal}
      open={open}
      onClose={handleClose}
      TitleBarComponent={titleBar}
      withoutFooter
      fullWidth
    >
      <div className={classes.modalContent}>
        <img
          className={classes.image}
          src={FishbowlSpinner.toString()}
          data-qa="fishbowl-spinner"
        ></img>
        <Typography variant="h6">We're Creating Your Account...</Typography>
        <Typography variant="body1">This May Take a Moment</Typography>
      </div>
    </Modal>
  );
};

export default CreateAccountModal;
